/**
 * External dependencies
 */
import React from "react";

interface Media {
	url?: string;
	source_url?: string;
	height: number;
	width: number;
}

interface Term {
	id: number;
	name: string;
	link: string;
}

interface StoryCardProps {
	title: string;
	link?: string;
	featured_image?: {
		[key in string]: Media;
	};
	default_image?: string;
	date?: string;
	date_formatted?: string;
	categories?: Term[];
	themes?: Term[];
	className?: string;
	readMoreText?: string;
}

const StoryCard = ({
	title,
	link,
	featured_image,
	date,
	date_formatted,
	themes,
	categories,
	className = "",
}: StoryCardProps) => {
	const componentClass = [
		"em-block-story-card",
		"animated",
		"duration--fast",
		"wrapper-link",
		"fadeIn",
		className,
	];

	return (
		<article className={componentClass.join(" ")}>
			<a href={link} className="em-block-story-card__link">
				<div className="em-block-story-card__image">
					<FeaturedImage image={featured_image} size="medium_large" />
				</div>
				<div className="em-block-story-card__content">
					<div className="em-block-story-card__info">
						{!!categories && (
							<ul className="em-block-story-card__terms">
								{categories.map(({ name }, index) => (
									<li
										className="em-block-story-card__term"
										key={index}
										dangerouslySetInnerHTML={{ __html: name }}
									/>
								))}
							</ul>
						)}
						<time dateTime={date_formatted} className="em-block-story-card__date">
							{date}<span className="screen-reader-text">.</span>
						</time>
					</div>
					<h3 className="em-block-story-card__title" dangerouslySetInnerHTML={{ __html: title }}></h3>
				</div>
			</a>
		</article>
	);
};

interface FeaturedImageProps {
	image?: Record<string, Media>;
	size?: string;
}

const FeaturedImage = ({
	image,
	size = "medium_large",
}: FeaturedImageProps) => {
	if (!image) {
		return null;
	}

	const imageSource = image[size] || image["full"];

	if (!imageSource || (!imageSource.url && !imageSource.source_url)) {
		return null;
	}

	return (
		<img
			src={imageSource.url || imageSource.source_url}
			width={imageSource.width}
			height={imageSource.height}
		/>
	);
};

export default StoryCard;
